
define('require-css/css!js-css/rsswidget',[],function(){});
